import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { IPublisher } from '../../shared/models';
import { EApplicationLogLevel, EElasticLogLevel, ElasticLogModel } from '../../shared/models/log.model';
import { LogPublishersService } from './log-publishers.service';

@Injectable()
export class LogService {
  private appLogLevel: EApplicationLogLevel = environment.log_level;
  private readonly publishers: IPublisher[] = [];

  constructor(private readonly logPubService: LogPublishersService) {
    this.publishers = this.logPubService.publishers;
  }

  private shouldNotBeLogged(level: EApplicationLogLevel): boolean {
    return this.appLogLevel === EApplicationLogLevel.Off || level < this.appLogLevel;
  }

  private mapAppLogLevelToElasticLogLevel(level: EApplicationLogLevel): EElasticLogLevel {
    switch (level) {
      case EApplicationLogLevel.Debug:
        return EElasticLogLevel.Debug;
      case EApplicationLogLevel.Info:
        return EElasticLogLevel.Info;
      case EApplicationLogLevel.Warn:
        return EElasticLogLevel.Warn;
      case EApplicationLogLevel.Error:
        return EElasticLogLevel.Error;
      default:
        return EElasticLogLevel.Debug;
    }
  }

  private writeToLog(msg: unknown, level: EApplicationLogLevel, collector: string): void {
    if (this.shouldNotBeLogged(level)) {
      return;
    }

    const elasticLogLevel = this.mapAppLogLevelToElasticLogLevel(level);
    const logEntry = new ElasticLogModel(msg, elasticLogLevel, collector);
    for (const logger of this.publishers) {
      logger.log(logEntry);
    }
  }

  debug(msg: unknown, collector: string): void {
    this.writeToLog(msg, EApplicationLogLevel.Debug, collector);
  }

  info(msg: unknown, collector: string): void {
    this.writeToLog(msg, EApplicationLogLevel.Info, collector);
  }

  warn(msg: unknown, collector: string): void {
    this.writeToLog(msg, EApplicationLogLevel.Warn, collector);
  }

  error(msg: unknown, collector: string): void {
    this.writeToLog(msg, EApplicationLogLevel.Error, collector);
  }
}
